﻿export const DocumentationConstants = {
    HomePage: 10,
    ProductPlanningForm: 20,
    ProductsForm: 21,
    BatchPlanningForm: 30,
    UsersManagementForm: 50,
    RawMaterialsForm: 100,
    AssetsForm: 200,
    GlasswareForm: 210,
    ColumnsForm: 220,
    StandardsForm: 300,
    ProductionBenchSheet: 500,
    GCBenchSheet: 1000,
    HPLCBenchSheet: 1001,
    ICBenchSheet: 1002,
    ICPBenchSheet: 1003,
    KFCBenchSheet: 1004,
    KFTBenchSheet: 1005,
    LODBenchSheet: 1006,
    ROEBenchSheet: 1007,
    ROIBenchSheet: 1008,
    HNMRBenchSheet: 1009,
    FTIRBenchSheet: 1010,
    QTOFBenchSheets: 1011,
    MICROBenchSheets: 1012,
    BPBenchSheets: 1013,
    CONDBenchSheets: 1014,
    DENSITYBenchSheets: 1015,
    MPBenchSheets: 1016,
    MRBenchSheets: 1017,
    ORBenchSheets: 1018,
    PHBenchSheets: 1019,
    RIBenchSheets: 1021,
    SGBenchSheets: 1022,
    TITRATIONBenchSheets: 1023,
    TOCBenchSheets: 1024,
    TURBBenchSheets: 1025,
    UVVISBenchSheets: 1026, 
    GCRSBenchSheets: 1027,
    AppearanceBenchSheets: 1028,
    GravimetricBenchSheets: 1029,
    TicketLogForm: 2000,
    ResourcesForm: 2100,
    ChemicalInventory: 2500,
    RawMaterialAnalysis: 3000,

}